var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNoPosts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 190,
  height: 190
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-no-posts_svg__a",
  x1: "100%",
  x2: "0%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F38036"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FC0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-no-posts_svg__b",
  x1: "98.389%",
  x2: "1.353%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-no-posts_svg__c",
  x1: "98.389%",
  x2: "1.353%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h190v190H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170.806,
  cy: 38.673,
  r: 8.523,
  fill: "url(#icon-no-posts_svg__a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.92,
  cy: 108.559,
  r: 16.193,
  fill: "url(#icon-no-posts_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M126.737 60H162a4 4 0 0 1 4 4v92H24V64a4 4 0 0 1 4-4h35.025"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M131.673 74H154a4 4 0 0 1 4 4v78H32V78a4 4 0 0 1 4-4h23.619"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon-no-posts_svg__c)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M69.524 99A35 35 0 0 0 86 108.831L86 133a4 4 0 0 1-4 4H44a4 4 0 0 1-4-4v-30a4 4 0 0 1 4-4Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42.016,
  cy: 82.252,
  r: 2.557,
  fill: "url(#icon-no-posts_svg__a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.687,
  cy: 82.252,
  r: 2.557,
  fill: "url(#icon-no-posts_svg__b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57.357,
  cy: 82.252,
  r: 2.557,
  fill: "url(#icon-no-posts_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M32 90h31M127 90h29.459M106 108h14"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  transform: "translate(60 40)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 35
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.598 56.528 91.071 85A5 5 0 1 1 84 92.071L55.384 63.455a35.2 35.2 0 0 0 7.214-6.927Z"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M106 118h24M106 128h26"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M12 156h166v12H12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M92.614 81.434q0-1.636.718-3.033a9.3 9.3 0 0 1 1.756-2.415 70 70 0 0 1 2.076-1.955 10.5 10.5 0 0 0 1.756-2.036q.718-1.097.718-2.295 0-1.676-1.157-2.574t-3.113-.898q-1.875 0-3.233.958T90.179 69.9l-3.951-2.235q1.117-2.834 3.612-4.37t5.647-1.537q3.552 0 6.147 2.035t2.594 5.628q0 1.676-.718 3.133-.72 1.457-1.757 2.494a97 97 0 0 1-2.075 2.016 11.2 11.2 0 0 0-1.756 2.095q-.718 1.118-.718 2.275zm4.43 8.382a2.88 2.88 0 0 1-2.115.878q-1.237 0-2.116-.878a2.88 2.88 0 0 1-.878-2.116q0-1.237.858-2.115t2.136-.878q1.237 0 2.115.878t.878 2.115-.878 2.116"
}))));
export default SvgIconNoPosts;